import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css';

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Om Sai Cab Service</title>

        <meta
          name="description"
          content="Privacy Policy for Om Sai Cab Service. Learn how we collect, use, and protect your personal information."
        />

        <meta
          name="keywords"
          content="Om Sai Cab Service, Taxi Service, Cab Booking, Outstation Cab, Local Cab Service"
        />
      </Helmet>

      {/* Breadcrumb */}
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white">
                Privacy Policy
              </h2>
            </div>
          </div>
        </div>
      </div>

      {/* Privacy Policy Section */}
      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-12">
<div className='img-fluid'>

<img className='img-fluid' src='/images/term.png' />
</div>
              <h3 className="title">
                Privacy Policy – Om Sai Cab Service
              </h3>

              <p>
                At <b>Om Sai Cab Service</b>, we value your privacy and are committed
                to protecting your personal information. This Privacy Policy
                explains how we collect, use, and safeguard your data when
                you use our cab booking and transportation services.
              </p>

              {/* Information We Collect */}
              <div className="section">
                <p className="highlight darkcolor">
                  Information We Collect:
                </p>

                <p className="highlight darkcolor">
                  1. Booking Information:
                </p>

                <p>
                  When you book a cab with Om Sai Cab Service, we may collect your
                  name, phone number, pickup and drop locations, travel dates,
                  and payment details.
                </p>

                <p className="highlight darkcolor">
                  2. Travel Details:
                </p>

                <p>
                  For local, airport, outstation, or corporate travel,
                  itinerary details may be collected for smooth service management.
                </p>

                <p className="highlight darkcolor">
                  3. Website Usage Information:
                </p>

                <p>
                  We may collect technical data such as browser type,
                  IP address, device information, and visited pages
                  to improve our website and customer experience.
                </p>
              </div>

              {/* How We Use Information */}
              <div className="section">
                <p className="highlight darkcolor">
                  How We Use Your Information:
                </p>

                <p className="highlight darkcolor">
                  1. Service Delivery:
                </p>

                <p>
                  Your data is used to confirm bookings, assign drivers,
                  manage routes, and provide transportation services efficiently.
                </p>

                <p className="highlight darkcolor">
                  2. Customer Communication:
                </p>

                <p>
                  We use your contact details to send booking confirmations,
                  trip updates, driver information, and customer support responses.
                </p>

                <p className="highlight darkcolor">
                  3. Service Improvement:
                </p>

                <p>
                  Information collected helps us improve service quality,
                  customer support, and overall operational efficiency.
                </p>

                <p className="highlight darkcolor">
                  4. Promotional Updates:
                </p>

                <p>
                  With your permission, we may send offers, discounts,
                  or updates related to Om Sai Cab services.
                </p>
              </div>

              {/* Information Sharing */}
              <div className="section">
                <p className="highlight darkcolor">
                  Information Sharing:
                </p>

                <p className="highlight darkcolor">
                  1. Drivers & Operations Team:
                </p>

                <p>
                  Necessary booking details such as your name,
                  phone number, and pickup location may be shared
                  with assigned drivers for trip completion.
                </p>

                <p className="highlight darkcolor">
                  2. Legal Compliance:
                </p>

                <p>
                  We may disclose information if required by law
                  or government authorities for legal or safety purposes.
                </p>
              </div>

              {/* Data Security */}
              <div className="section">
                <p className="highlight darkcolor">
                  Data Security:
                </p>

                <p>
                  We implement reasonable security measures to protect
                  your personal data. However, no online system can
                  guarantee complete security.
                </p>

                <p className="highlight darkcolor">
                  Your Rights:
                </p>

                <p>
                  You may request access, correction, or deletion
                  of your personal information and opt out of
                  promotional communication at any time.
                </p>

                <p className="highlight darkcolor">
                  Policy Updates:
                </p>

                <p>
                  Om Sai Cab Service may update this Privacy Policy periodically.
                  Updated policies will be posted on this page.
                </p>
              </div>

            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Us</h2>

            <p>
              If you have any questions regarding this Privacy Policy,
              please contact us:
            </p>

            <ul>
              <li>
                <b>Phone:</b>{' '}
                <a href="tel:+919594849797">
                  +91 9594849797
                </a>
              </li>

              <li>
                <b>Email:</b>{' '}
                <a href="mailto:booking@omsaicabservice.com">
                  booking@omsaicabservice.com
                </a>
              </li>

              <li>
                <b className="darkcolorrrr">Address:</b>
                <br />

                <h6>Om Sai Cab Service</h6>

                  Shree Vishal CHS Ltd.,
Office -13 Plot <br/> No.17, Sector 18, Kopar Khairane,<br/> Navi Mumbai, Maharashtra 400709
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;